import { createContext } from "react";

export const CategoriesContext = createContext(null);
